import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8c08a32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dental-card__observation observation" }
const _hoisted_2 = { class: "observation__dynamic dynamic" }
const _hoisted_3 = { class: "dynamic__header" }
const _hoisted_4 = { class: "dynamic__plaque-status" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "dynamic__title title" }, [
  /*#__PURE__*/_createTextVNode(" Динамика "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" гигиены ")
], -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" налёт ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" налёт ")
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "dynamic__health-status" }
const _hoisted_11 = { class: "dynamic__health-status--block" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "small-text" }, "/ 100", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "уровень здоровья", -1))
const _hoisted_15 = {
  key: 0,
  class: "dynamic__content"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "dynamic__subtitle small-text subtitle" }, "Ваш первый приём", -1))
const _hoisted_17 = { class: "dynamic__block" }
const _hoisted_18 = { class: "dynamic__date small-text" }
const _hoisted_19 = { class: "dynamic__first-report text" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Это Ваш первый отчет ")
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" о гигиене полости рта. ")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Ваш ")
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "текущий", -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" результат — ")
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "dynamic__supporting-phrase small-text subtitle" }, [
  /*#__PURE__*/_createTextVNode(" Отличный результат! "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Соблюдайте домашнюю гигиену "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" и сохраняйте здоровье. ")
], -1))
const _hoisted_29 = {
  key: 1,
  class: "dynamic__content"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "dynamic__subtitle small-text subtitle" }, " C предыдущего визита ", -1))
const _hoisted_31 = { class: "dynamic__row" }
const _hoisted_32 = { class: "dynamic__supporting-phrase small-text subtitle" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Уровень налёта на ")
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "предыдущем", -1))
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" приёме ")
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = { class: "dynamic__supporting-phrase small-text subtitle" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Уровень налёта на ")
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "текущем", -1))
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" приёме ")
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_44 = { class: "observation__plan plan" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "Личный план приёмов", -1))
const _hoisted_46 = { class: "plan__text small-text" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" План составлен с помощью искусственного интеллекта DIANA. ")
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Рекомендуемые визиты на год для снижения % налета и сохранения здоровых зубов: ")
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_51 = { class: "plan__content" }
const _hoisted_52 = { class: "plan__context--value text" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" налёт ")
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "plan__context--subtitle small-text" }, [
  /*#__PURE__*/_createTextVNode(" всего за "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "1 приём")
], -1))
const _hoisted_56 = { class: "plan__context--value text" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" налёт ")
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "plan__context--subtitle small-text" }, [
  /*#__PURE__*/_createTextVNode(" и далее приёмы "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "1 раз в полгода")
], -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "plan__subtitle small-text subtitle" }, [
  /*#__PURE__*/_createTextVNode(" Для достижения этого результата важно не пропускать приемы, следовать рекомендациям врача и "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" соблюдать домашнюю гигиену. При успешном соблюдении графика ваши зубы будут здоровыми, а "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, " временные интервалы между приёмами профессиональной гигиены будут увеличиваться! ")
], -1))

import { computed, ref, watch } from 'vue'
import { Chart, ChartOptions, registerables } from 'chart.js'
import { LineChart, useLineChart } from 'vue-chart-3'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import {
  AppointmentType,
  ObservationHistoryType,
  ResultAnalyzesType,
} from '@/shared/types'
import gradient from 'chartjs-plugin-gradient'
import { PlaqueReportController } from '@/pages/PlaqueReportPage/plaqueReport'
import { DATE_FORMAT } from '@/shared/constants'
import { useRoute } from 'vue-router'

interface Props {
  totalPlaque: number
  observationHistory: ObservationHistoryType[]
  appointments: AppointmentType
  plaqueReportController: PlaqueReportController
  resultAnalyzes: ResultAnalyzesType
}


export default /*#__PURE__*/_defineComponent({
  props: {
    totalPlaque: null,
    observationHistory: null,
    appointments: null,
    plaqueReportController: null,
    resultAnalyzes: null
  },
  setup(__props: any) {

const props = __props as {
  totalPlaque: number
  observationHistory: ObservationHistoryType[]
  appointments: AppointmentType
  plaqueReportController: PlaqueReportController
  resultAnalyzes: ResultAnalyzesType
}

Chart.register(...registerables)



const route = useRoute()
const reportId = computed(() => route.params.reportId)
const isVisible = ref(true)
const isFirstReport = computed(() => {
  const currentId = props.observationHistory.indexOf(currentReport.value)
  return currentId === props.observationHistory.length - 1
})
const totalPlaque = computed<number>(() => props.totalPlaque)
const months = computed(() =>
  props.plaqueReportController.getMonths().slice(1).join(', ')
)
const firstDate = computed(() =>
  props.plaqueReportController.getFirstDateAppointment()
)
const spacesValues = computed(() => props.appointments?.spacesValues)

const previousReportData = computed(() => {
  if (!props.observationHistory) {
    return
  }
  const NEXT_REPORT_DISTANCE = 1

  const currentReportIndex = props.observationHistory.indexOf(
    currentReport.value
  )
  const previousReport =
    props.observationHistory[currentReportIndex + NEXT_REPORT_DISTANCE]

  if (!previousReport) {
    return
  }

  const value = previousReport.day + previousReport.long
  const formattedDate = props.plaqueReportController.getFormatedDateForPDF(
    new Date(previousReport.dateAt),
    DATE_FORMAT.myShort
  )

  return {
    date: formattedDate,
    value,
  }
})

const currentReport = computed(() => {
  return props.observationHistory.find((date) => {
    return date.id === Number(reportId.value)
  })
})

const datesLabels = computed(() => {
  return props.appointments?.shortDates.map((date) => date?.date)
})

const differences = computed(() => {
  return props.appointments?.differences.filter(Boolean) ?? []
})

const gradientOptions = {
  backgroundColor: {
    axis: 'y',
    colors: {
      0: 'rgba(197, 245, 240, 0.3)',
      10: 'rgba(197, 245, 240, 0.5)',
      20: 'rgba(182, 183, 249, 0.5)',
      28: 'rgba(253, 160, 160, 0.5)',
      33: 'rgba(241, 113, 121, 0.5)',
    },
  },
  borderColor: {
    axis: 'y',
    colors: {
      0: 'rgba(197, 245, 240, 1)',
      20: 'rgba(182, 183, 249, 1)',
      28: 'rgba(253, 160, 160, 1)',
      33: 'rgba(241, 113, 121, 1)',
    },
  },
  pointColor: {
    axis: 'y',
    colors: {
      0: 'rgba(197, 245, 240, 1)',
      20: 'rgba(182, 183, 249, 1)',
      28: 'rgba(253, 160, 160, 1)',
      33: 'rgba(241, 113, 121, 1)',
    },
  },
}

const chartDataPlans = computed(() => {
  return {
    labels: datesLabels.value,
    datasets: [
      {
        label: 'Индекс налёта',
        cubicInterpolationMode: 'monotone',
        spanGaps: true,
        gradient: gradientOptions,
        fill: true,
        data: props.appointments?.levels,
      },
    ],
  }
})

const chartDataDynamic = computed(() => {
  return {
    labels: [
      previousReportData.value?.date,
      props.appointments?.shortDates[0].date,
    ],
    datasets: [
      {
        label: 'Индекс налёта',
        cubicInterpolationMode: 'monotone',
        spanGaps: true,
        gradient: gradientOptions,
        fill: true,
        data: [
          Math.round(previousReportData.value?.value),
          props.appointments?.levels[0],
        ],
      },
    ],
  }
})

const chartOptionsPlan = computed<ChartOptions<'line'>>(() => {
  return {
    plugins: {
      gradient,
      datalabels: {
        color: '#272727',
        font: {
          family: 'SF Pro Display',
          weight: 'bold',
        },
        formatter: (value, context) => {
          const i = context.dataIndex

          if (i === 0 || context.chart.scales.x.ticks.length === 2) {
            return value + '%'
          }

          return ''
        },
        align: 'top',
        offset: 2,
      },
      legend: {
        display: false,
      },
    },
    layout: {
      padding: {
        left: 15,
        right: 15,
        top: 20,
      },
    },
    elements: {
      point: {
        radius: 1.5,
        borderWidth: 2.5,
      },
      line: {
        borderWidth: 1,
      },
    },
    scales: {
      y: {
        grace: 4,
        min: 0,
        beginAtZero: true,
        display: false,
      },
      x: {
        grid: {
          borderColor: 'white',
          color: 'rgba(39, 39, 39, 0.05)',
          drawTicks: false,
          borderDash: [2, 2],
        },
        ticks: {
          callback: function (val: number) {
            return this.getLabelForValue(val) ? this.getLabelForValue(val) : ''
          },
          font: {
            size: 9,
          },
          align: 'inner',
          autoSkip: false,
          maxRotation: 0,
          padding: 10,
          color: function (context) {
            if (context.index === 0) {
              return 'rgba(61,138,254,0)'
            }
            if (context.tick.label != '') {
              return 'rgba(39, 39, 39, 1)'
            } else {
              return 'rgba(61,138,254,0)'
            }
          },
        },
      },
    },
  }
})
const chartOptionsDynamic = computed<ChartOptions<'line'>>(() => {
  return {
    plugins: {
      gradient,
      datalabels: {
        color: '#272727',
        font: {
          family: 'SF Pro Display',
          weight: 'bold',
        },
        formatter: (value, context) => {
          const i = context.dataIndex

          if (i === 0 || context.chart.scales.x.ticks.length === 2) {
            return value + '%'
          }

          return ''
        },
        align: 'top',
        offset: 2,
      },
      legend: {
        display: false,
      },
    },
    layout: {
      padding: {
        left: 15,
        right: 15,
        top: 20,
      },
    },
    elements: {
      point: {
        radius: 1.5,
        borderWidth: 2.5,
      },
      line: {
        borderWidth: 1,
      },
    },
    scales: {
      y: {
        grace: 4,
        min: 0,
        beginAtZero: true,
        display: false,
      },
      x: {
        grid: {
          borderColor: 'white',
          color: 'rgba(39, 39, 39, 0.05)',
          drawTicks: false,
          borderDash: [2, 2],
        },
        ticks: {
          callback: function (val: number) {
            return this.getLabelForValue(val) ? this.getLabelForValue(val) : ''
          },
          font: {
            size: 9,
          },
          align: 'inner',
          autoSkip: false,
          maxRotation: 0,
          padding: 10,
          color: function (context) {
            if (context.tick.label != '') {
              return 'rgba(39, 39, 39, 1)'
            } else {
              return 'rgba(61,138,254,0)'
            }
          },
        },
      },
    },
  }
})

const planChart = ref<Chart>()

function switchOnOff() {
  isVisible.value = false
  setTimeout(() => {
    isVisible.value = true
  }, 200)
}

const margins = computed(() => {
  if (spacesValues.value?.length) {
    const firstSpace = spacesValues.value[0]
    const secondSpace = spacesValues.value[1]

    const marginFirst = planChart.value?.scales?.x.getPixelForTick(firstSpace)
    const marginSecond = planChart.value?.scales?.x.getPixelForTick(
      firstSpace + secondSpace
    )

    return { marginFirst, marginSecond }
  }
})

const handleChartRender = (chart: Chart) => {
  if (chart.scales.x?.ticks && chart.scales.x?.ticks[0]) {
    planChart.value = chart
  }
}

watch(reportId, () => {
  switchOnOff()
})

const { lineChartProps: lineChartPlansProps } = useLineChart({
  // @ts-ignore
  chartData: chartDataPlans,
  options: chartOptionsPlan,
})

const { lineChartProps: lineChartDymicProps } = useLineChart({
  // @ts-ignore
  chartData: chartDataDynamic,
  options: chartOptionsDynamic,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          (_unref(isFirstReport))
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: _normalizeClass([{
              'dynamic__plaque-value_great': _unref(totalPlaque) < 10,
              'dynamic__plaque-value_warning':
                _unref(totalPlaque) >= 10 && _unref(totalPlaque) < 30,
              'dynamic__plaque-value_danger': _unref(totalPlaque) >= 30,
            }, "dynamic__plaque-value text"])
              }, [
                _hoisted_6,
                _createElementVNode("span", null, _toDisplayString(Math.round(_unref(totalPlaque))) + "%", 1)
              ], 2))
            : (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: _normalizeClass([{
              'dynamic__plaque-value_great': _unref(totalPlaque) < 10,
              'dynamic__plaque-value_warning':
                _unref(totalPlaque) >= 10 && _unref(totalPlaque) < 30,
              'dynamic__plaque-value_danger': _unref(totalPlaque) >= 30,
            }, "dynamic__plaque-value text"])
              }, [
                _hoisted_7,
                (_unref(totalPlaque) - _unref(previousReportData)?.value < 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(Math.round(_unref(totalPlaque) - _unref(previousReportData)?.value)) + "% ", 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, " +" + _toDisplayString(Math.round(_unref(totalPlaque) - _unref(previousReportData)?.value)) + "% ", 1))
              ], 2))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_12, [
                _createTextVNode(_toDisplayString(Math.round(100 - _unref(totalPlaque))) + " ", 1),
                _hoisted_13
              ]),
              _hoisted_14
            ])
          ])
        ])
      ]),
      (_unref(isFirstReport))
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(firstDate)), 1),
              _createElementVNode("p", _hoisted_19, [
                _hoisted_20,
                _hoisted_21,
                _hoisted_22,
                _hoisted_23,
                _hoisted_24,
                _hoisted_25,
                _hoisted_26,
                _hoisted_27,
                _createTextVNode(" " + _toDisplayString(Math.round(_unref(totalPlaque))) + "% налета. ", 1)
              ])
            ]),
            _hoisted_28
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _hoisted_30,
            _createVNode(_unref(LineChart), _mergeProps({
              plugins: [_unref(ChartDataLabels), _unref(gradient)],
              class: "chart chart_dynamic"
            }, _unref(lineChartDymicProps)), null, 16, ["plugins"]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("p", _hoisted_32, [
                _hoisted_33,
                _hoisted_34,
                _hoisted_35,
                _hoisted_36,
                _hoisted_37,
                _createTextVNode(" составлял " + _toDisplayString(Math.round(_unref(previousReportData)?.value)) + "% ", 1)
              ]),
              _createElementVNode("p", _hoisted_38, [
                _hoisted_39,
                _hoisted_40,
                _hoisted_41,
                _hoisted_42,
                _hoisted_43,
                _createTextVNode(" составил " + _toDisplayString(Math.round(__props.appointments?.levels[0])) + "% ", 1)
              ])
            ])
          ]))
    ]),
    _createElementVNode("div", _hoisted_44, [
      _hoisted_45,
      _createElementVNode("p", _hoisted_46, [
        _hoisted_47,
        _hoisted_48,
        _hoisted_49,
        _hoisted_50,
        _createElementVNode("span", null, _toDisplayString(_unref(months)), 1)
      ]),
      _createElementVNode("div", _hoisted_51, [
        (_unref(differences).length && isVisible.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([{
            plan__context_great: _unref(differences)[0] >= 10 && _unref(differences)[0] < 30,
            plan__context_normal: _unref(differences)[0] < 10,
            plan__context_danger: _unref(differences)[0] >= 30,
          }, "plan__context"]),
              style: _normalizeStyle({
            left: _unref(margins).marginFirst + 11 + 'px',
            top: '90px',
          })
            }, [
              _createElementVNode("p", _hoisted_52, [
                _hoisted_53,
                _hoisted_54,
                _createElementVNode("span", null, "-" + _toDisplayString(Math.floor(_unref(differences)[0])) + "%", 1)
              ]),
              _hoisted_55
            ], 6))
          : _createCommentVNode("", true),
        (_unref(differences).length && isVisible.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass([{
            plan__context_great: _unref(differences)[1] >= 10 && _unref(differences)[1] < 30,
            plan__context_normal: _unref(differences)[1] < 10,
            plan__context_danger: _unref(differences)[1] >= 30,
          }, "plan__context"]),
              style: _normalizeStyle({
            left: _unref(margins).marginSecond + 11 + 'px',
            top: '100px',
          })
            }, [
              _createElementVNode("p", _hoisted_56, [
                _hoisted_57,
                _hoisted_58,
                _createElementVNode("span", null, "-" + _toDisplayString(Math.floor(_unref(differences)[1])) + "%", 1)
              ]),
              _hoisted_59
            ], 6))
          : _createCommentVNode("", true),
        (isVisible.value)
          ? (_openBlock(), _createBlock(_unref(LineChart), _mergeProps({
              key: 2,
              plugins: [_unref(ChartDataLabels), _unref(gradient)],
              class: "chart"
            }, _unref(lineChartPlansProps), { "onChart:render": handleChartRender }), null, 16, ["plugins"]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_60
    ])
  ]))
}
}

})